import React from 'react'
import "../styles/TopBanner.css";

const TopBanner = () => {
  return (
    <div className='container'>
        <div>WATCH GRAND THEFT AUTO VI TRAILER 1 NOW</div>
    </div>
  )
}

export default TopBanner;